import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { GeoFenceHistoryRequest } from "./GeoFenceHistoryRequest";
import { BTBusHistorySelectorBusRequest } from "../../bus-tracker-bus-history/shared/BTBusHistorySelectorBusRequest";
import { BTBusHistorySelectorStudentRequest } from "../../bus-tracker-bus-history/shared/BTBusHistorySelectorStudentRequest";
import { BTBusGetPersonPhotosRequest } from "./BTBusGetPersonPhotosRequest";

@Injectable()
export class DataService_BusTrackerGeoFenceHistory {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	BusMapPreferenceSelect(PersonID) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusMapPreferenceSelect?PersonID=" + PersonID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GeoFenceHistoryBusInfoGetList(parms: GeoFenceHistoryRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/GeoFenceHistoryBusInfoGetList";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GeoFenceHistorySelectorBusModeSelectList(parms: BTBusHistorySelectorBusRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/GeoFenceHistorySelectorBusModeSelectList";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GeoFenceHistorySelectorStudentModeSelectList(parms: BTBusHistorySelectorStudentRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/GeoFenceHistorySelectorStudentModeSelectList";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GeoFenceHistoryHeatMapSelectList(UserID) {
		var postResult$ = new Subject();
		var url = "BusTracker/GeoFenceHistoryHeatMapSelectList?UserID=" + UserID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GeoFenceSelectList() {
		var postResult$ = new Subject();
		var url = "BusTracker/GeoFenceSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PersonGetImage(PersonID) {
		var postResult$ = new Subject();
		var url = "BusTracker/PersonGetImage?PersonID=" + PersonID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusGetPersonPhotos(parms: BTBusGetPersonPhotosRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusGetPersonPhotos";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
